// extracted by mini-css-extract-plugin
export default {"container":"MdtFeedbackTypeformList_container__flMRU"};